<template>
  <div class="wt-ellipsis-animation" />
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.wt-ellipsis-animation {
  display: inline-block;
  width: 0;

  &:before {
    content: '...';
    white-space: pre;
    animation: rotateDots 1s infinite;
    font-weight: 200;
    font-size: 8px;
    font-family: monospace;

    @keyframes rotateDots {
      0% {
        content: '   ';
      }
      33% {
        content: '.  ';
      }
      66% {
        content: '.. ';
      }
    }
  }
}
</style>
